import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getPublicServices } from '../../services/serviceService';
import { Service } from '../../types/service';
import styles from './PublicServicesPage.module.css'; // ملف تنسيقات جديد وجذاب
import { FaCheckCircle, FaArrowLeft } from 'react-icons/fa';
import pageStyles from '../Page.module.css';
import Icon from '../../components/common/Icon';

const PublicServicesPage: React.FC = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getPublicServices()
      .then(setServices)
      .catch(err => console.error("Failed to fetch public services:", err))
      .finally(() => setIsLoading(false));
  }, []);

  const handleRequestServiceClick = () => {
    // المنطق الموحد الذي تحدثنا عنه
    if (isAuthenticated) {
      // إذا كان المستخدم مسجلاً، انقله إلى لوحة التحكم لتقديم الطلب
      navigate('/dashboard/request-service');
    } else {
      // إذا لم يكن مسجلاً، انقله إلى صفحة التسجيل
      navigate('/register');
    }
  };

  if (isLoading) {
    return <div className={styles.statusMessage}>جاري تحميل الخدمات...</div>;
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.header}>
        <h1>خدمات النقابة الإلكترونية</h1>
        <p>تصفح جميع الخدمات المتاحة وقدم طلبك بسهولة وأمان.</p>
      </div>

      <div className={styles.servicesGrid}>
        {services.map(service => (
          <div key={service.id} className={styles.serviceCard}>
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{service.name}</h3>
              <p className={styles.cardDescription}>{service.description}</p>
              <div className={styles.cardFee}>
                <span>رسوم الخدمة:</span>
                <strong>{service.fee} ريال</strong>
              </div>
            </div>
            <div className={styles.cardFooter}>
              <button onClick={handleRequestServiceClick} className={styles.requestButton}>
                <span>اطلب الخدمة الآن</span>
                  <Icon as={FaArrowLeft} style={pageStyles.icon } />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PublicServicesPage;
